import { ProjectDataInformation } from './project-data-information.entity';
import { ProjectDataPuerta } from './project-data-puerta.entity';
import { ProjectDataProducto } from './project-data-producto.entity';
import { ProjectDataPresupuesto } from './project-data-presupuesto-entity';

export class ProjectDataPerimetro {
	public zIndex: number;

	public id?: string;
	public longitudML? = 0;
	public longitud = 0;
	public longitudStr: string = '';
	public coordenadas: any[] = [];
	public informacion: ProjectDataInformation = new ProjectDataInformation();
	public puertas: ProjectDataPuerta[] = [];
	public producto: ProjectDataProducto = new ProjectDataProducto();
	public presupuesto: ProjectDataPresupuesto = new ProjectDataPresupuesto();
	public seqPerimetro: number = -1;
	public grid: any[];
	public vat = 0;
	public subtotal = 0;
	public descuento = 0;
	public aplicado = 0;
	public vatTotal = 0;
	public total = 0;
	public subtotalStr = '';
	public descuentoStr = '';
	public aplicadoStr = '';
	public vatTotalStr = '';
	public totalStr = '';
	public dotsBreak?: any[];
	public tramos?: number[];
	public post?: number[];
	public desnivel?: number;
	public error = '';
	public css?: {
		SVGClassBreak: string,
		SVGClassPoint: string,
		SVGClassLine: string
	};
}
